export { useDrillPageResetAnswerInputOnCharacterChange } from "#use-drill-page-reset-answer-input-on-character-change";
